import React from "react";
import { Card, Container } from "react-bootstrap";

const ShippingPolicy = () => {
  return (
    <Container className="my-5 site-content">
      <Card className="p-4">
        <Card.Body>
          <h1 className="text-center mb-4 fs-3">Shipping Policy</h1>

          <section className="mb-4">
            <h2 className="fs-5">Introduction</h2>
            <p>
            Welcome to <b>Sheenlac Noroo Coatings Pvt. Ltd. (a unit of Sheenlac Paints Ltd.)</b>, your one-stop-shop for all types of paints. We are committed to
              delivering our products in a timely and efficient manner. Our
              shipping policy is designed to provide you with a clear
              understanding of our shipping processes and procedures.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">1. General Information</h2>
            <p>
              All orders are subject to product availability. If an item is not
              in stock at the time you place your order, we will notify you and
              refund you the total amount of your order, using the original
              method of payment.
            </p>
            <p>
              Items offered on our website are only available for delivery to
              addresses in India. Any shipments outside of these areas are not
              available currently.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">2. Delivery Location</h2>
            <p>
              Items are shipped from our warehouse to the shipping address
              provided by the customer.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">3. Delivery Time</h2>
            <p>
              An estimated delivery time will be provided once your order is
              placed. Delivery times are estimates and commence from the date of
              shipping, rather than the date of order.
            </p>
            <p>
              Delivery times are to be used as a guide only and are subject to
              the acceptance and approval of your order.
            </p>
            <p>
              Unless there are exceptional circumstances, we will deliver the
              product in minimum 7 to 15 business days from the date of your order. Business
              days mean Monday to Friday, except holidays. Please note we do not
              ship on Holidays as per the government.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">4. Shipping Costs</h2>
            <p>
              Shipping costs are based on the weight of your order and the
              shipping method selected. To find out how much your order will
              cost, simply add the items you would like to purchase to your cart
              and proceed to the checkout page. At the checkout screen, shipping
              charges will be displayed.
            </p>
            <p>
              Additional shipping charges may apply to remote areas or for large
              or heavy items. You will be advised of any charges on the checkout
              page.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">5. Damaged Items in Transport</h2>
            <p>
              If there is any damage to the packaging on delivery, contact us
              immediately at{" "}
              <a href="tel:080-47493330" className="link-secondary">
                080-47493330
              </a>
              .
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">6. Queries</h2>
            <p>
              If you have any queries about the delivery and shipment of your
              order, please contact us at{" "}
              <a href="tel:080-47493330" className="link-secondary">
                080-47493330
              </a>
              .
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">7. Tracking</h2>
            <p>
              You will receive a Shipment Confirmation email once your order has
              shipped containing your tracking number(s). The tracking number
              will be active within 24 hours.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">Thank You</h2>
            <p>
              Thank you for shopping with Sheenlac Noroo Coatings Pvt. Ltd. (a unit of Sheenlac Paints Ltd.). We strive to meet
              your expectations with every order you place.
            </p>
          </section>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ShippingPolicy;